export const ANIMATIONS = [
  { id: 'none', name: 'Static' },
  { id: 'zoom-in', name: 'Ken Burns In' },
  { id: 'zoom-out', name: 'Ken Burns Out' },
  { id: 'pan-left', name: 'Pan Left' },
  { id: 'pan-right', name: 'Pan Right' },
];

export const TRANSITIONS = [
  { id: 'none', name: 'Cut' },
  { id: 'fade', name: 'Crossfade' },
  { id: 'slide-left', name: 'Slide L' },
  { id: 'slide-right', name: 'Slide R' },
  { id: 'wipe-left', name: 'Wipe L' },
  { id: 'wipe-right', name: 'Wipe R' },
  { id: 'dissolve', name: 'Dissolve' },
];

export const SPEED_PRESETS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2, 3, 4, 6, 8, 10];

export const SPEED_RAMPS = {
  none: { name: 'Constant', points: [[0, 1], [1, 1]], color: '#94a3b8' },
  fast_in_slow_out: { name: 'Fast\u2192Slow', points: [[0, 3], [0.3, 2], [0.7, 1.2], [1, 0.8]], color: '#f59e0b' },
  slow_in_fast_out: { name: 'Slow\u2192Fast', points: [[0, 0.8], [0.3, 1.2], [0.7, 2], [1, 3]], color: '#3b82f6' },
  pulse: { name: 'Pulse', points: [[0, 1], [0.15, 2.5], [0.35, 0.8], [0.5, 2.5], [0.65, 0.8], [0.85, 2.5], [1, 1]], color: '#ec4899' },
  dramatic_slowmo: { name: 'Drama', points: [[0, 2], [0.2, 0.4], [0.5, 0.3], [0.8, 0.4], [1, 2]], color: '#8b5cf6' },
  ramp_up: { name: 'Ramp Up', points: [[0, 0.5], [0.5, 1], [1, 3]], color: '#10b981' },
  ramp_down: { name: 'Ramp Down', points: [[0, 3], [0.5, 1], [1, 0.5]], color: '#ef4444' },
  bounce: { name: 'Bounce', points: [[0, 1], [0.25, 3], [0.5, 0.5], [0.75, 3], [1, 1]], color: '#06b6d4' },
};

export const TRANSITION_LABELS = Object.fromEntries(TRANSITIONS.map(t => [t.id, t.name]));

export const PX_PER_SEC = 60;
export const LABEL_W = 56;
export const RULER_H = 22;
export const VIDEO_H = 52;
export const AUDIO_H = 30;
export const LAYER_H = 26;

/** Calculate effective playback duration accounting for speed ramps */
export const getEffDur = (t) => {
  const dur = t.duration || 3;
  const rampId = t.speed_ramp;

  if (!rampId || rampId === 'none') {
    return dur / Math.max(0.1, t.speed_factor || 1);
  }

  // Custom ramp: use track's speed_ramp_points
  if (rampId === 'custom') {
    const pts = t.speed_ramp_points;
    if (!pts || pts.length < 2) return dur;
    let total = 0;
    for (let i = 1; i < pts.length; i++) {
      const segFrac = pts[i][0] - pts[i - 1][0];
      const avgSpeed = (pts[i][1] + pts[i - 1][1]) / 2;
      total += (dur * segFrac) / Math.max(0.1, avgSpeed);
    }
    return total;
  }

  // Preset ramp
  const ramp = SPEED_RAMPS[rampId];
  if (!ramp) return dur / Math.max(0.1, t.speed_factor || 1);

  const points = ramp.points;
  let total = 0;
  for (let i = 1; i < points.length; i++) {
    const segFrac = points[i][0] - points[i - 1][0];
    const avgSpeed = (points[i][1] + points[i - 1][1]) / 2;
    total += (dur * segFrac) / Math.max(0.1, avgSpeed);
  }
  return total;
};
